import React from 'react';
import { ActionPrompt } from '../../game/presentation';

const ActionBanner: React.FC<{ prompt: ActionPrompt }> = ({ prompt }) => (
  <div className={`ss-banner is-${prompt.tone}`} role="status" aria-live="polite">
    <h2>{prompt.headline}</h2>
    <p>{prompt.detail}</p>
  </div>
);

export default ActionBanner;
